import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AppBody from "../Body";
import ErrorBoundary from "../ErrorBoundary";
import AppFooter from "../Footer";
import AppHeader from "../Header/Header";
import IsOnline from "../IsOnline";
import classes from "./AppLayout.module.css";
import { useAppContext } from "../../Context/AppContext";
import { useMixPanelForTracking } from "../../shared_utilities/trackMixPanel";

const AppLayout = () => {
  const { transporterInfo } = useAppContext();
  const { TrackMixPanel } = useMixPanelForTracking();

  useEffect(() => {
    TrackMixPanel({
      ModuleName: "App Layout",
      ScreenName: "Landing Page",
      Definition: "user session started",
    });
  }, []);
  
  // They are in onboarding if there is data but no name yet
  const isOnboarding = transporterInfo && !transporterInfo.transporter_name;

  return (
    <div className={classes["app-layout"]} style={isOnboarding ? { gridTemplateRows: 'max-content 0px auto 0px' } : {}}>
      <BrowserRouter>
        <ErrorBoundary>
          <IsOnline />
          {!isOnboarding && <AppHeader />}
          <AppBody />
          {!isOnboarding && <AppFooter />}
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
};

export default AppLayout;
